import { getWebFunnelsConfig } from 'helpers/getWebFunnelsConfig'
import { useMemo } from 'react'
import type { IWebFunnelsConfigFile } from 'root-constants'
import { useShallow } from 'zustand/shallow'
import { useZustandSessionStore } from 'zustandGlobalSessionStore'
import { useZustandStore } from 'zustandGlobalStore'

type TFunnelsConfig = {
  config: IWebFunnelsConfigFile
  isReady: boolean
}

export const useFunnelsConfig = (): TFunnelsConfig => {
  const { growthbook, cohort, country } = useZustandStore(
    useShallow((state) => ({
      growthbook: state.growthbook,
      cohort: state.lead?.cohort || state.initialCohort,
      country: state.lead?.country || '',
    })),
  )
  const language = useZustandSessionStore((state) => state.language)

  return useMemo(
    () => ({
      config: getWebFunnelsConfig(growthbook),
      isReady: !!growthbook,
    }),
    // growthbook mutates its attributes in place via setAttributes, so cohort/
    // country/language must stay as deps to force recomputation when targeting changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [growthbook, cohort, country, language],
  )
}
